// extracted by mini-css-extract-plugin
export default {"component":"Lock__component-riaF","fadeOut":"Lock__fadeOut-jPw_"};